module.exports = __webpack_public_path__ + "static/img/external_unit.4bef05c.png";


//////////////////
// WEBPACK FOOTER
// ./img/project-design/external_unit.png
// module id = 1013
// module chunks = 1